export default __webpack_public_path__ + "static/illustration-card-logo.url-91c52473e0cf3ac286c378bd3512b136.svg";